import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { useMedia } from 'react-use';

import { Bar, Progress, Step, Text, Wrapper } from './Steps.style';

const stepTextTransition = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

interface Props {
    videoSources: {
        [key: number]: {
            mp4: string;
            webm: string;
            duration: number;
        };
    };
    step: number;
    setStep: (step: number) => void;
}

export function Steps({ videoSources, step, setStep }: Props) {
    const isMobile = useMedia('(max-width: 1000px)');

    return (
        <Wrapper>
            <Step onClick={() => setStep(1)}>
                <Progress $current={step === 1}>
                    {step === 1 && (
                        <Bar
                            animate={isMobile ? { width: '100%' } : { height: '100%' }}
                            transition={{ duration: videoSources[step].duration }}
                            onAnimationComplete={() => setStep(2)}
                        />
                    )}
                </Progress>
                <AnimatePresence>
                    {((isMobile && step === 1) || !isMobile) && (
                        <Text {...stepTextTransition}>Own your one-of-a-kind emoji username</Text>
                    )}
                </AnimatePresence>
            </Step>
            <Step onClick={() => setStep(2)}>
                <Progress $current={step === 2}>
                    {step === 2 && (
                        <Bar
                            animate={isMobile ? { width: '100%' } : { height: '100%' }}
                            transition={{ duration: videoSources[step].duration }}
                            onAnimationComplete={() => setStep(3)}
                        />
                    )}
                </Progress>
                <AnimatePresence>
                    {((isMobile && step === 2) || !isMobile) && (
                        <Text {...stepTextTransition}>It’s how everyone connects with you</Text>
                    )}
                </AnimatePresence>
            </Step>
            <Step onClick={() => setStep(3)}>
                <Progress $current={step === 3}>
                    {step === 3 && (
                        <Bar
                            animate={isMobile ? { width: '100%' } : { height: '100%' }}
                            transition={{ duration: videoSources[step].duration }}
                            onAnimationComplete={() => setStep(1)}
                        />
                    )}
                </Progress>
                <AnimatePresence>
                    {((isMobile && step === 3) || !isMobile) && (
                        <Text {...stepTextTransition}>And how everyone pays you</Text>
                    )}
                </AnimatePresence>
            </Step>
        </Wrapper>
    );
}
